// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.OsGJKuybA2Nm2I {
  position: absolute;
  z-index: 5;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: hidden;
}
._eVRFnTWuhoMfF {
  position: relative;
  width: 100%;
  border-radius: 8px 8px 0px 0px;
}
.OLVTocfMASH9Hj {
  z-index: unset;
  margin: 0px 40px;
  overflow: visible;
}
.HkHn0QTh8MTkn_ {
  position: absolute;
  top: 20px;
  right: -50px;
  bottom: 50px;
  left: 50px;
  overflow: visible;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"stickersWrapper": `OsGJKuybA2Nm2I`,
	"stickers": `_eVRFnTWuhoMfF`,
	"cardBackStickersWrapper": `OLVTocfMASH9Hj`,
	"cardBackStickers": `HkHn0QTh8MTkn_`
};
export default ___CSS_LOADER_EXPORT___;
